module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "60bb":
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "9331":
/***/ (function(module, exports) {

module.exports = require("papaparse");

/***/ }),

/***/ "cebe":
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"5c251374-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/VueCsvImport.vue?vue&type=template&id=37f8ab8d&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-csv-uploader"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"vue-csv-uploader-part-one"},[(_vm.headers === null)?_c('div',{staticClass:"form-check form-group csv-import-checkbox"},[_vm._t("hasHeaders",[_c('input',{class:_vm.checkboxClass,attrs:{"type":"checkbox","id":"hasHeaders"},domProps:{"value":_vm.hasHeaders},on:{"change":_vm.toggleHasHeaders}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"hasHeaders"}},[_vm._v("\n                        File Has Headers\n                    ")])],{"headers":_vm.hasHeaders,"toggle":_vm.toggleHasHeaders})],2):_vm._e(),_c('div',{staticClass:"form-group csv-import-file"},[_c('input',{ref:"csv",class:_vm.inputClass,attrs:{"type":"file","name":"csv"},on:{"change":function($event){$event.preventDefault();return _vm.validFileMimeType($event)}}}),(_vm.showErrorMessage && !_vm.validedFileMimeType)?_vm._t("error",[_vm._v("\n                    File type is invalid\n                ")]):_vm._e()],2),_c('div',{staticClass:"form-group"},[_vm._t("next",[_c('button',{class:_vm.buttonClass,attrs:{"type":"submit","disabled":_vm.disabledNextButton},on:{"click":function($event){$event.preventDefault();return _vm.load($event)}}},[_vm._v("\n                        "+_vm._s(_vm.loadBtnText)+"\n                    ")])],{"load":_vm.load})],2)]),_c('div',{staticClass:"vue-csv-uploader-part-two"},[(_vm.sample)?_c('div',{staticClass:"vue-csv-mapping"},[_c('table',{class:_vm.tableClass},[_vm._t("thead",[_vm._m(0)]),_c('tbody',_vm._l((_vm.fieldsToMap),function(field,key){return _c('tr',{key:key},[_c('td',[_vm._v(_vm._s(field.label))]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.map[field.key]),expression:"map[field.key]"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.map, field.key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.firstRow),function(column,key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v(_vm._s(column))])}),0)])])}),0)],2),(_vm.url)?_c('div',{staticClass:"form-group"},[_vm._t("submit",[_c('input',{class:_vm.buttonClass,attrs:{"type":"submit"},domProps:{"value":_vm.submitBtnText},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}})],{"submit":_vm.submit})],2):_vm._e()]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Field")]),_c('th',[_vm._v("CSV Column")])])])}]


// CONCATENATED MODULE: ./src/components/VueCsvImport.vue?vue&type=template&id=37f8ab8d&

// EXTERNAL MODULE: external {"commonjs":"lodash","commonjs2":"lodash","root":"_"}
var external_commonjs_lodash_commonjs2_lodash_root_ = __webpack_require__("60bb");
var external_commonjs_lodash_commonjs2_lodash_root_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_lodash_commonjs2_lodash_root_);

// EXTERNAL MODULE: external {"commonjs":"axios","commonjs2":"axios","root":"axios"}
var external_commonjs_axios_commonjs2_axios_root_axios_ = __webpack_require__("cebe");
var external_commonjs_axios_commonjs2_axios_root_axios_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_axios_commonjs2_axios_root_axios_);

// EXTERNAL MODULE: external {"commonjs":"papaparse","commonjs2":"papaparse","root":"papaparse"}
var external_commonjs_papaparse_commonjs2_papaparse_root_papaparse_ = __webpack_require__("9331");
var external_commonjs_papaparse_commonjs2_papaparse_root_papaparse_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_papaparse_commonjs2_papaparse_root_papaparse_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/VueCsvImport.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var VueCsvImportvue_type_script_lang_js_ = ({
  props: {
    value: Array,
    url: {
      type: String
    },
    mapFields: {
      required: true
    },
    callback: {
      type: Function,
      default: function _default() {}
    },
    catch: {
      type: Function,
      default: function _default() {}
    },
    finally: {
      type: Function,
      default: function _default() {}
    },
    parseConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    headers: {
      default: null
    },
    loadBtnText: {
      type: String,
      default: "Next"
    },
    submitBtnText: {
      type: String,
      default: "Submit"
    },
    tableClass: {
      type: String,
      default: "table"
    },
    checkboxClass: {
      type: String,
      default: "form-check-input"
    },
    buttonClass: {
      type: String,
      default: "btn btn-primary"
    },
    inputClass: {
      type: String,
      default: "form-control-file"
    },
    fileMimeTypes: {
      type: Array,
      default: function _default() {
        return ["text/csv"];
      }
    }
  },
  data: function data() {
    return {
      form: {
        csv: null
      },
      fieldsToMap: [],
      map: {},
      hasHeaders: true,
      csv: null,
      sample: null,
      validedFileMimeType: false,
      fileSelected: false
    };
  },
  created: function created() {
    this.hasHeaders = this.headers;

    if (external_commonjs_lodash_commonjs2_lodash_root_default.a.isArray(this.mapFields)) {
      this.fieldsToMap = external_commonjs_lodash_commonjs2_lodash_root_default.a.map(this.mapFields, function (item) {
        return {
          key: item,
          label: item
        };
      });
    } else {
      this.fieldsToMap = external_commonjs_lodash_commonjs2_lodash_root_default.a.map(this.mapFields, function (label, key) {
        return {
          key: key,
          label: label
        };
      });
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.form.csv = this.buildMappedCsv();
      this.$emit('input', this.form.csv);

      if (this.url) {
        external_commonjs_axios_commonjs2_axios_root_axios_default.a.post(this.url, this.form).then(function (response) {
          _this.callback(response);
        }).catch(function (response) {
          _this.catch(response);
        }).finally(function (response) {
          _this.finally(response);
        });
      } else {
        _this.callback(this.form.csv);
      }
    },
    buildMappedCsv: function buildMappedCsv() {
      var _this = this;

      var csv = this.hasHeaders ? external_commonjs_lodash_commonjs2_lodash_root_default.a.drop(this.csv) : this.csv;
      return external_commonjs_lodash_commonjs2_lodash_root_default.a.map(csv, function (row) {
        var newRow = {};

        external_commonjs_lodash_commonjs2_lodash_root_default.a.forEach(_this.map, function (column, field) {
          external_commonjs_lodash_commonjs2_lodash_root_default.a.set(newRow, field, external_commonjs_lodash_commonjs2_lodash_root_default.a.get(row, column));
        });

        return newRow;
      });
    },
    validFileMimeType: function validFileMimeType() {
      var file = this.$refs.csv.files[0];

      if (file) {
        this.validedFileMimeType = this.fileMimeTypes.indexOf(file.type) > -1 ? true : false;
        this.fileSelected = true;
      } else {
        this.validedFileMimeType = false;
        this.fileSelected = false;
      }
    },
    load: function load() {
      var _this = this;

      this.readFile(function (output) {
        _this.sample = external_commonjs_lodash_commonjs2_lodash_root_default.a.get(external_commonjs_papaparse_commonjs2_papaparse_root_papaparse_default.a.parse(output, {
          preview: 2,
          skipEmptyLines: true
        }), "data");
        _this.csv = external_commonjs_lodash_commonjs2_lodash_root_default.a.get(external_commonjs_papaparse_commonjs2_papaparse_root_papaparse_default.a.parse(output, {
          skipEmptyLines: true
        }), "data");
      });
    },
    readFile: function readFile(callback) {
      var file = this.$refs.csv.files[0];

      if (file) {
        var reader = new FileReader();
        reader.readAsText(file, "UTF-8");

        reader.onload = function (evt) {
          callback(evt.target.result);
        };

        reader.onerror = function () {};
      }
    },
    toggleHasHeaders: function toggleHasHeaders() {
      this.hasHeaders = !this.hasHeaders;
    }
  },
  watch: {
    map: {
      handler: function handler(newVal) {
        if (!this.url) {
          var hasAllKeys = this.mapFields.every(function (item) {
            return newVal.hasOwnProperty(item);
          });

          if (hasAllKeys) {
            this.submit();
          }
        }
      },
      deep: true
    }
  },
  computed: {
    firstRow: function firstRow() {
      return external_commonjs_lodash_commonjs2_lodash_root_default.a.get(this, "sample.0");
    },
    showErrorMessage: function showErrorMessage() {
      return this.fileSelected;
    },
    disabledNextButton: function disabledNextButton() {
      return !this.validedFileMimeType;
    }
  }
});
// CONCATENATED MODULE: ./src/components/VueCsvImport.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VueCsvImportvue_type_script_lang_js_ = (VueCsvImportvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/VueCsvImport.vue





/* normalize component */

var component = normalizeComponent(
  components_VueCsvImportvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VueCsvImport = (component.exports);
// CONCATENATED MODULE: ./src/index.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



var VueCsvImportPlugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Vue.component(options.componentName || 'VueCsvImport', VueCsvImport);
  }
};

if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && window.Vue && window.Vue === external_commonjs_vue_commonjs2_vue_root_Vue_default.a) {
  install(window.Vue);
}


/* harmony default export */ var src = (VueCsvImport);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
/* concated harmony reexport VueCsvImport */__webpack_require__.d(__webpack_exports__, "VueCsvImport", function() { return VueCsvImport; });
/* concated harmony reexport VueCsvImportPlugin */__webpack_require__.d(__webpack_exports__, "VueCsvImportPlugin", function() { return VueCsvImportPlugin; });


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ })

/******/ });
//# sourceMappingURL=VueCsvImport.common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-csv-import/dist/VueCsvImport.common.js
// module id = 932
// module chunks = 0